import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardAlertInfo } from "../alert/StandardAlertInfo"
import { HIDDEN_IN_PRINT } from "../print/printPageOnly"

import { ContactInfoPrintFooter } from "./ContactInfoPrintFooter"

const useStyles = makeStyles()(() => ({
    disclaimer: HIDDEN_IN_PRINT,
}))

type ContactInfoDisclaimerProps = Readonly<{
    className?: string
}>

export function ContactInfoDisclaimer({ className }: ContactInfoDisclaimerProps) {
    const { classes, cx } = useStyles()

    return (
        <>
            <LocalizedStrict id="meeting-service-contact-info-disclaimer" attrs={{ title: true }}>
                <StandardAlertInfo
                    title="Customer contact information. Handle it with care."
                    className={cx(classes.disclaimer, className)}
                />
            </LocalizedStrict>
            <ContactInfoPrintFooter />
        </>
    )
}
